import { QUESTIONS, RESULT_SLUGS } from './constants.js'

export const getResultSlug = (selectedAnswers) => {
  const groups = QUESTIONS.map((question) => question.group).reduce(
    (acc, group) => (acc.includes(group) ? acc : [...acc, group]),
    []
  )

  const values = groups.map((group) => {
    const answers = []
    QUESTIONS.forEach((question, index) => {
      if (question.group === group) {
        answers.push(selectedAnswers[index])
      }
    })
    return getResultFunctions[group](answers)
  })
  return RESULT_SLUGS[values.join('')]
}

const getMostFrequentValues = (array) => {
  const countMap = {}

  array.forEach((item) => (countMap[item] = (countMap[item] || 0) + 1))

  const maxCount = Math.max(...Object.values(countMap))
  return Object.keys(countMap).filter((key) => countMap[key] === maxCount)
}

const getResultFunctions = {
  season: (selectedAnswers) => {
    const mostFrequentValues = getMostFrequentValues(selectedAnswers)
    return mostFrequentValues.length > 1
      ? getMostFrequentValues([
          ...selectedAnswers,
          selectedAnswers[0],
          selectedAnswers[0],
        ])[0]
      : mostFrequentValues[0]
  },
  personality: (selectedAnswers) => {
    return getMostFrequentValues(selectedAnswers)[0]
  },
}
